import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import styles from "./PageLayout.module.scss";
import Header from "../../library/component/header";
import Footer from "../../library/component/footer/Footer";

import { routerConfig } from "../../routes";
import { BottomNavigation } from "../../library/component";
import ScrollToTop from "./ScrollToTop";
import Analytics from "../../library/component/Google Analytics/Analytics";

const PageLayout = () => {
  const aiClick = () => {
    window.open(
      "https://kevali.jainglory.in",
      "_blank",
      "noopener, noreferrer"
    );
  };

  return (
    <Router>
      <ScrollToTop />
      <div className={styles.layoutWrapper}>
        <Header />
        <div className={styles.chatbotWrapper}>
          <img
            src="/assets/icons/chatbot_icon.png"
            className={styles.chatbot_icon}
            alt="Chatbot Icon"
            onClick={aiClick}
          />
        </div>

        <div className={styles.pageLayoutContainer}>
          <div className={styles.childContainer}>
            <Analytics />
            <Routes>
              {routerConfig?.map((n, i) => (
                <Route key={i} {...n} />
              ))}
            </Routes>
          </div>
        </div>
        <Footer />
      </div>
      <BottomNavigation />
    </Router>
  );
};

export default PageLayout;
